import {
    registerCustomDetailComponent,
    addActionBarItem,
    ActionBarContext,
    ActionBarButtonState,
} from '@vendure/admin-ui/core';
import { firstValueFrom, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomerValidationComponent } from './components/customer-validation/customer-validation.component';
import { ProductValidationComponent } from './components/product-validation/product-validation.component';
import gql from 'graphql-tag';

const EXPORT_PRODUCTS_WITH_ERRORS = gql`
    query ExportProductsWithErrors {
        exportProductsWithErrors(filter: UPDATED)
    }
`;

const EXPORT_CUSTOMERS_WITH_ERRORS = gql`
    query ExportCustomersWithErrors {
        exportCustomersWithErrors(filter: UPDATED)
    }
`;

const EXPORT_PRODUCTS_WITH_ERRORS_ALL = gql`
    query ExportProductsWithErrors {
        exportProductsWithErrors(filter: ALL)
    }
`;

const EXPORT_CUSTOMERS_WITH_ERRORS_ALL = gql`
    query ExportCustomersWithErrors {
        exportCustomersWithErrors(filter: ALL)
    }
`;

const productLoading$ = new BehaviorSubject(false);
const customerLoading$ = new BehaviorSubject(false);

export default [
    // Detail Components
    registerCustomDetailComponent({
        locationId: 'customer-detail',
        component: CustomerValidationComponent,
    }),
    registerCustomDetailComponent({
        locationId: 'product-detail',
        component: ProductValidationComponent,
    }),

    // Product export button
    addActionBarItem({
        id: 'export-products-errors',
        label: 'Produtos com Erros Hoje',
        locationId: 'product-list',
        icon: 'download',
        buttonState: (_context: ActionBarContext) => {
            return productLoading$
                .asObservable()
                .pipe(
                    map((isLoading) => ({ disabled: isLoading, visible: true }))
                );
        },
        onClick: async (_event, context) => {
            try {
                productLoading$.next(true);
                context.notificationService.info(
                    'Exportando produtos com erros hoje, aguarde...'
                );

                const res: any = await firstValueFrom(
                    context.dataService.query(EXPORT_PRODUCTS_WITH_ERRORS)
                        .stream$
                );

                const url = res.exportProductsWithErrors;
                if (url) {
                    window.open(url, '_blank');
                    context.notificationService.success(
                        'Arquivo exportado com sucesso!'
                    );
                } else {
                    context.notificationService.error(
                        'Nenhum arquivo retornado'
                    );
                }
            } catch (err: any) {
                context.notificationService.error('Erro: ' + err.message);
            } finally {
                productLoading$.next(false);
            }
        },
        requiresPermission: 'ReadCatalog',
    }),

    addActionBarItem({
        id: 'export-products-errors-all',
        label: 'Todos os Produtos Com Erros',
        locationId: 'product-list',
        icon: 'download',
        buttonState: (_context: ActionBarContext) => {
            return productLoading$
                .asObservable()
                .pipe(
                    map((isLoading) => ({ disabled: isLoading, visible: true }))
                );
        },
        onClick: async (_event, context) => {
            try {
                productLoading$.next(true);
                context.notificationService.info(
                    'Exportando todos os produtos com erros, aguarde...'
                );

                const res: any = await firstValueFrom(
                    context.dataService.query(EXPORT_PRODUCTS_WITH_ERRORS_ALL)
                        .stream$
                );

                const url = res.exportProductsWithErrors;
                if (url) {
                    window.open(url, '_blank');
                    context.notificationService.success(
                        'Arquivo exportado com sucesso!'
                    );
                } else {
                    context.notificationService.error(
                        'Nenhum arquivo retornado'
                    );
                }
            } catch (err: any) {
                context.notificationService.error('Erro: ' + err.message);
            } finally {
                productLoading$.next(false);
            }
        },
        requiresPermission: 'ReadCatalog',
    }),

    // Customer export button
    addActionBarItem({
        id: 'export-customers-errors',
        label: 'Clientes com Erros Hoje',
        locationId: 'customer-list',
        icon: 'download',
        buttonState: (_context: ActionBarContext) => {
            return customerLoading$
                .asObservable()
                .pipe(
                    map((isLoading) => ({ disabled: isLoading, visible: true }))
                );
        },
        onClick: async (_event, context) => {
            try {
                customerLoading$.next(true);
                context.notificationService.info(
                    'Exportando customers com erros hoje, aguarde...'
                );

                const res: any = await firstValueFrom(
                    context.dataService.query(EXPORT_CUSTOMERS_WITH_ERRORS)
                        .stream$
                );

                const url = res.exportCustomersWithErrors;
                if (url) {
                    window.open(url, '_blank');
                    context.notificationService.success(
                        'Arquivo exportado com sucesso!'
                    );
                } else {
                    context.notificationService.error(
                        'Nenhum arquivo retornado'
                    );
                }
            } catch (err: any) {
                context.notificationService.error('Erro: ' + err.message);
            } finally {
                customerLoading$.next(false);
            }
        },
        requiresPermission: 'ReadCustomer',
    }),

    addActionBarItem({
        id: 'export-customers-errors-all',
        label: 'Todos os Clientes com Erros',
        locationId: 'customer-list',
        icon: 'download',
        buttonState: (_context: ActionBarContext) => {
            return customerLoading$
                .asObservable()
                .pipe(
                    map((isLoading) => ({ disabled: isLoading, visible: true }))
                );
        },
        onClick: async (_event, context) => {
            try {
                customerLoading$.next(true);
                context.notificationService.info(
                    'Exportando todos os customers com erros, aguarde...'
                );

                const res: any = await firstValueFrom(
                    context.dataService.query(EXPORT_CUSTOMERS_WITH_ERRORS_ALL)
                        .stream$
                );

                const url = res.exportCustomersWithErrors;
                if (url) {
                    window.open(url, '_blank');
                    context.notificationService.success(
                        'Arquivo exportado com sucesso!'
                    );
                } else {
                    context.notificationService.error(
                        'Nenhum arquivo retornado'
                    );
                }
            } catch (err: any) {
                context.notificationService.error('Erro: ' + err.message);
            } finally {
                customerLoading$.next(false);
            }
        },
        requiresPermission: 'ReadCustomer',
    }),
];
